import { createApp } from 'vue'
import App from '@/App.vue'
// 引入路由
import router from '@/router'
// 引入store
import store from '@/store'

// 引入公共样式
// import 'element-plus/dist/index.css'  //ElementPlus的样式,放在第一个，方便下边覆盖
import '@/styles/element/index.scss'
import '@/assets/css/public.scss'


// 引入element-plus
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import {PerfectScrollbar} from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/style.css'
import DynamicTable from "@/components/DynamicTable.vue";
import DynamicForm from "@/components/DynamicForm.vue";

// api接口统一管理
import * as api from '@/api'
import apiList from '@/api/apiList.js'
// 引入工具函数
import * as  utils from '@/utils/index.js'
import "vue-global-api"

const app = createApp(App);
// 挂载路由和store
app.use(store)
    .use(router)
    .use(ElementPlus, { locale: zhCn });

// 挂载api接口
app.config.globalProperties.$api = api;
app.config.globalProperties.$apiList = apiList;
app.config.globalProperties.$utils = utils;

app.provide('$api', api)
app.provide('$apiList', apiList)
app.provide('$utils', utils)

// 全局注册图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.component('VuePerfectScrollbar', PerfectScrollbar);
app.component('DynamicTable', DynamicTable);
app.component('DynamicForm', DynamicForm);
app.mount('#app')
